var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 7h12q.066 0 .128.008l-5.837 4.17a.5.5 0 0 1-.582 0l-5.837-4.17Q5.935 7 6 7m-.94.657A1 1 0 0 0 5 8v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-.06-.343l-6.068 4.335a1.5 1.5 0 0 1-1.744 0zM4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
});
const SvgMail = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDdIMThDMTguMDQzNSA3IDE4LjA4NjMgNy4wMDI3NyAxOC4xMjgzIDcuMDA4MTVMMTIuMjkwNSAxMS4xNzc5QzEyLjExNjcgMTEuMzAyMSAxMS44ODMxIDExLjMwMjEgMTEuNzA5MyAxMS4xNzc5TDUuODcxNjggNy4wMDgxNkM1LjkxMzY5IDcuMDAyNzcgNS45NTY1MiA3IDYgN1pNNS4wNjAyMSA3LjY1NzQ0QzUuMDIxMjUgNy43NjQzIDUgNy44Nzk2NyA1IDhWMTZDNSAxNi41NTIzIDUuNDQ3NzIgMTcgNiAxN0gxOEMxOC41NTIzIDE3IDE5IDE2LjU1MjMgMTkgMTZWOEMxOSA3Ljg3OTY2IDE4Ljk3ODcgNy43NjQyOSAxOC45Mzk4IDcuNjU3NDNMMTIuODcxNyAxMS45OTE3QzEyLjM1MDIgMTIuMzY0MiAxMS42NDk2IDEyLjM2NDIgMTEuMTI4IDExLjk5MTdMNS4wNjAyMSA3LjY1NzQ0Wk00IDhDNCA2Ljg5NTQzIDQuODk1NDMgNiA2IDZIMThDMTkuMTA0NiA2IDIwIDYuODk1NDMgMjAgOFYxNkMyMCAxNy4xMDQ2IDE5LjEwNDYgMTggMTggMThINkM0Ljg5NTQzIDE4IDQgMTcuMTA0NiA0IDE2VjhaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";